import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { Deal } from 'app/models/dto/deal.model';
import { Document } from 'app/models/dto/document.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DealApplicationRequirement } from './deal-application-requirement.model';

const baseUrl = `${environment.API_URL}`;

@Injectable({
  providedIn: 'root'
})
export class DealDocumentsService {

  constructor(
    private http: ApiHttpClient
  ) {}

  // gets all deal document requirements
  getDocumentRequirements(loanProductId: number): Observable<DealApplicationRequirement[]> {
    return this.http.get<DealApplicationRequirement[]>(`${baseUrl}/matching/loan-product/${loanProductId}/documents`);
  }

  attachSignedApplication(dealId: number, signedApplicationDocId: number): Observable<Deal> {
    return this.http.put<Deal>(`${baseUrl}/deal/${dealId}`, { signedApplicationDocId });
  }

  detachSignedApplication(dealId: number): Observable<Deal> {
    return this.http.put<Deal>(`${baseUrl}/deal/${dealId}`, { signedApplicationDocId: null });
  }

  uploadDealDocument(file: File, borrowerId: number, dealId: number, category: string): Observable<Document> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('dealId', `${dealId}`);
    formData.append('category', category);
    formData.append('borrowerId', `${borrowerId}`);
    formData.append('attach', 'true');
    return this.http.post<Document>(`${baseUrl}/document`, formData).pipe(
      map((document: any) => {
        document.lenderUser = document.lender_user;
        return document;
      })
    );
  }
}
